var map = {
	"./SVG curve-2.svg": "2e21",
	"./SVG curve.svg": "aa44",
	"./check.svg": "4a24",
	"./chevron.svg": "3e50",
	"./chicken-sticker.svg": "b111",
	"./close.svg": "bb7c",
	"./css.svg": "fe2c",
	"./eggs-sticker.svg": "a3f3",
	"./email.svg": "da8d",
	"./facebook.svg": "7e4b",
	"./firebase.svg": "845a",
	"./fruits-sticker.svg": "9083",
	"./git.svg": "9fb7",
	"./github.svg": "76f4",
	"./globe.svg": "716e",
	"./grid-blue.svg": "65f8",
	"./grid-gray.svg": "1d72",
	"./grid.svg": "14a4",
	"./html.svg": "b6a4",
	"./instagram.svg": "48d6",
	"./js.svg": "41f1",
	"./logo-2.svg": "7fca",
	"./logo-light.svg": "c0d8",
	"./logo.svg": "a5f7",
	"./menu.svg": "1f69",
	"./mongodb.svg": "7e49",
	"./motion-path.svg": "d88d",
	"./node.svg": "932a",
	"./notes.svg": "b017",
	"./pencil.svg": "be21",
	"./pork-sticker.svg": "763c",
	"./quote-left.svg": "6118",
	"./quote-right.svg": "4c2c",
	"./sass.svg": "8619",
	"./twitter.svg": "5a0b",
	"./user.svg": "4d66",
	"./veggie-sticker.svg": "23a8",
	"./vuejs.svg": "3970"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "46f5";